import { authorizedRequest } from 'shared/api/axios';
import { RegionInfoDto, UpdateRegionDto } from '@sr/dto';

export interface RegionsFilter {
  countryId?: number;
  name?: string;
}

export const fetchRegions = async (filter?: RegionsFilter) => {
  const params = new URLSearchParams();
  
  if (filter?.countryId) {
    params.append('countryId', filter.countryId.toString());
  }
  
  if (filter?.name) {
    params.append('name', filter.name);
  }
  
  const queryString = params.toString();
  const url = queryString ? `/regions?${queryString}` : '/regions';
  
  return authorizedRequest<void, RegionInfoDto[]>(url, 'GET');
};

export const fetchRegionsDropdown = async (countryId?: number | null) => {
  const params = new URLSearchParams();

  if (countryId) {
    params.append('countryId', countryId.toString());
  }

  const queryString = params.toString();
  const url = queryString ? `/regions/dropdown?${queryString}` : '/regions/dropdown';

  return authorizedRequest<void, RegionInfoDto[]>(url, 'GET');
};

export const fetchRegionDetails = async (regionId: number) => {
  return authorizedRequest<void, RegionInfoDto>(
    `/regions/${regionId}`,
    'GET'
  );
};

export const putRegion = async (regionId: number, data: UpdateRegionDto) => {
  return authorizedRequest<UpdateRegionDto, RegionInfoDto>(
    `/regions/${regionId}`,
    'PUT',
    data
  );
};
